import * as _ from 'lodash'
import { ClubInfo, ClubOption, ClubRules, CombinationRule } from '@store/matchupStore'
import {
  BET_CANCEL_TYPE,
  BET_HIT_STATE,
  BET_TYPE_ON,
  CLUB_MEMBER_STATE,
  LS_SPORT_ID,
  PROPERTY_ID,
  SPORT_ID,
} from 'adv-protocol/src/GameCommon'
import {
  LEGACY_REGULAR_ODDS,
  LEGACY_REGULAR_OUTCOMES,
  LS_REGULAR_ODDS,
  LS_REGULAR_ODDS_HANDICAP,
  LS_REGULAR_ODDS_UNDEROVER,
  LS_REGULAR_ODDS_WAY,
  LS_REGULAR_OUTCOMES,
  UNIFIED_REGULAR_ODDS,
  UNIFIED_REGULAR_ODDS_HANDICAP,
  UNIFIED_REGULAR_ODDS_UNDEROVER,
  UNIFIED_REGULAR_ODDS_WAY,
  UNIFIED_REGULAR_OUTCOMES,
} from '@game-type/game-market-types'
import { Schema$Outcome } from '@protocol/game'
import { Schema$ClubRules } from '@interface/rules'
import { formatNumber, isLsportsEnv } from '@utils/utils'
import { globalStore } from '@store/index'
import { RATIO_TICKET } from '@constants/index'
import { TimelineEvent, TimelineEventType } from '@interface/chat'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import { ProducerType } from '@game-type/betradar-type'

dayjs.extend(duration)

export function ClubMemberStateToText(state: number) {
  let str = ''
  switch (state) {
    case CLUB_MEMBER_STATE.NONE:
      str = '비회원'
      break
    case CLUB_MEMBER_STATE.SEEK_MEMBER:
      str = '승인 대기중'
      break
    case CLUB_MEMBER_STATE.DENIED:
      str = '승인 거부'
      break
    case CLUB_MEMBER_STATE.APPROVED:
      str = '승인됨'
      break
    case CLUB_MEMBER_STATE.MEMBER:
      str = '회원'
      break
    case CLUB_MEMBER_STATE.SELF_OUT:
      str = '탈퇴'
      break
  }
  return str
}

export function HitStateToText(state: number, betCancelType = BET_CANCEL_TYPE.NONE) {
  let str = ''
  switch (state) {
    case BET_HIT_STATE.ONGOING:
      str = '대기'
      break
    case BET_HIT_STATE.SUCCESS:
      str = '적중'
      break
    case BET_HIT_STATE.FAIL:
      str = '미적중'
      break
    case BET_HIT_STATE.CANCEL:
      if (betCancelType !== BET_CANCEL_TYPE.NONE) {
        str = '베팅취소'
      } else {
        str = '적특'
      }
      break
  }
  return str
}

export const G_ICON = '{GIcon}'

export const ENABLE_MIN_BET_RATE = 1.01

export const ArrDayText = ['일', '월', '화', '수', '목', '금', '토']

// comnbination data
const REGULAR_COMBINATION_ORDER = ['way', 'handi', 'uo']

// const OLD_REGULAR_ODDS_FIELD = ['1', 'X', '2', 'Under', 'Over']

// const OLD_REGULAR_ODDS = ['10', '20', '51', '228', '56', '60', '229']

export const REGULAR_ODDS_KEY = {
  '1': 'way',
  '186': 'way',
  '219': 'way',
  '251': 'way',

  '16': 'handi',
  '223': 'handi',
  '237': 'handi',
  '256': 'handi',

  '18': 'uo',
  '225': 'uo',
  '238': 'uo',
  '258': 'uo',
}

export const LS_REGULAR_ODDS_KEY = {
  '1': 'way',
  '52': 'way',
  '226': 'way',

  '3': 'handi',
  '342': 'handi',
  '1558': 'handi',

  '2': 'uo',
  '28': 'uo',
}

const DefaultCombinationRuleExt = {
  'way-handi': {
    '1-1714': false,
    '2-1714': false,
    '3-1714': false,
    '4-1714': false,
    '5-1714': false,
    '1-1715': false,
    '2-1715': false,
    '3-1715': false,
    '4-1715': false,
    '5-1715': false,
  },
  'way-uo': {
    '1-13': true,
    '2-13': true,
    '3-13': true,
    '4-13': true,
    '5-13': true,
    '1-12': true,
    '2-12': true,
    '3-12': true,
    '4-12': true,
    '5-12': true,
  },
  'handi-uo': {
    '1714-13': true,
    '1714-12': true,
    '1715-13': true,
    '1715-12': true,
  },
  'special': false,
}

const LsDefaultCombinationRuleExt = {
  'way-handi': {
    '5-3': false, // Home hcp
    '6-3': false,
    '7-3': false,
    '5-4': false, // Away hcp
    '6-4': false,
    '7-4': false,
  },
  'way-uo': {
    '5-1': true, // Under
    '6-1': true,
    '7-1': true,
    '5-2': true, // Over
    '6-2': true,
    '7-2': true,
  },
  'handi-uo': {
    '3-1': true, // Home hcp, Under
    '3-2': true, // Home hcp, Over
    '4-1': true, // Away Hcp, Under
    '4-2': true, // Away Hcp, Over
  },
  'special': false,
}

export interface CombinationRuleExt {
  'way-handi': {
    [index_outcomeKey:string]: boolean
    // '1-1714': boolean
    // '2-1714': boolean
    // '3-1714': boolean
    // '4-1714': boolean
    // '5-1714': boolean
    // '1-1715': boolean
    // '2-1715': boolean
    // '3-1715': boolean
    // '4-1715': boolean
    // '5-1715': boolean
  }
  'way-uo': {
    [index_outcomeKey:string]: boolean
    // '1-13': boolean
    // '2-13': boolean
    // '3-13': boolean
    // '4-13': boolean
    // '5-13': boolean
    // '1-12': boolean
    // '2-12': boolean
    // '3-12': boolean
    // '4-12': boolean
    // '5-12': boolean
  }
  'handi-uo': {
    [index_outcomeKey:string]: boolean
    // '1714-13': boolean
    // '1714-12': boolean
    // '1715-13': boolean
    // '1715-12': boolean
  }

  'special': boolean
}

export interface CombitionSource {
  marketType: string // REGULAR_ODDS_KEY value
  outcome: string // odds field key
}

export const canSportCombinations = (
  rule: CombinationRuleExt,
  src: CombitionSource[],
  test: CombitionSource,
): boolean => {
  const allowed = true
  for (const el of src) {
    if (el.marketType === test.marketType) {
      continue
    }
    let srcKey = REGULAR_ODDS_KEY[el.marketType]
    let testKey = REGULAR_ODDS_KEY[test.marketType]
    if (isLsportsEnv()) {
      srcKey = LS_REGULAR_ODDS_KEY[el.marketType]
      testKey = LS_REGULAR_ODDS_KEY[test.marketType]
    }
    if (!srcKey || !testKey) {
      continue
    }
    const srcIdx = REGULAR_COMBINATION_ORDER.indexOf(srcKey)
    const testIdx = REGULAR_COMBINATION_ORDER.indexOf(testKey)
    if (srcIdx === testIdx) {
      return false
    }
    const ruleKey = srcIdx < testIdx ? `${srcKey}-${testKey}` : `${testKey}-${srcKey}`
    const ruleField = srcIdx < testIdx ? `${el.outcome}-${test.outcome}` : `${test.outcome}-${el.outcome}`

    if (!rule[ruleKey]) {
      return false
    }

    if (!rule[ruleKey][ruleField]) {
      return false
    }
  }
  return allowed
}

export const canGameTypesFoldCount = (gameKey: string, count: number, rules: Schema$ClubRules) => {
  const ret = {
    allowed: true,
    message: '',
  }
  let txt
  switch (gameKey) {
    case 'cross':
      if (count === 1 && rules.crossSingleUse === false) {
        txt = '크로스 싱글 베팅'
      }
      if (count > 1 && rules.crossMultiUse === false) {
        txt = '크로스 멀티 베팅'
      }
      break
    case 'way':
      if (count === 1 && rules.waySingleUse === false) {
        txt = '승무패 싱글 베팅'
      }
      if (count > 1 && rules.wayMultiUse === false) {
        txt = '승무패 멀티 베팅'
      }
      break
    case 'uo':
      if (count === 1 && rules.hcuoSingleUse === false) {
        txt = '핸디캡/언더오버 싱글 베팅'
      }
      if (count > 1 && rules.hcuoMultiUse === false) {
        txt = '핸디캡/언더오버 멀티 베팅'
      }
      break
    case 'special':
      if (count === 1 && rules.specialSingleUse === false) {
        txt = '스페셜 싱글 베팅'
      }
      if (count > 1 && rules.specialMultiUse === false) {
        txt = '스페셜 멀티 베팅'
      }
      break
  }
  if (txt) {
    ret.allowed = false
    ret.message = `클럽 설정으로 ${txt}이 불가능합니다.`
  }
  return ret
}

function overrideCombinations(dest: CombinationRule, src: CombinationRule) {
  if (dest && src) {
    dest.WinUnder = src.WinUnder
    dest.WinOver = src.WinOver
    dest.TieUnder = src.TieUnder
    dest.TieOver = src.TieOver
    dest.LoseUnder = src.LoseUnder
    dest.LoseOver = src.LoseOver
    dest.HandiUnder = src.HandiUnder
    dest.HandiOver = src.HandiOver
    dest.SpecialCombination = src.SpecialCombination
  }
}

export const getSportCombinations = (rules: ClubRules, gameKey: string, sportId: number): CombinationRuleExt => {
  const ruleBase: CombinationRule = {
    WinUnder: true,
    WinOver: true,
    TieUnder: true,
    TieOver: true,
    LoseUnder: true,
    LoseOver: true,
    HandiUnder: true,
    HandiOver: true,
    SpecialCombination : false,
  }

  overrideCombinations(ruleBase, rules?.sportCombinations?.[sportId])

  let rule: CombinationRuleExt
  if (isLsportsEnv()) {
    rule = _.cloneDeep(LsDefaultCombinationRuleExt)
    rule['way-uo']['5-1'] = ruleBase.WinUnder
    rule['way-uo']['6-1'] = ruleBase.TieUnder
    rule['way-uo']['7-1'] = ruleBase.LoseUnder
    rule['way-uo']['5-2'] = ruleBase.WinOver
    rule['way-uo']['6-2'] = ruleBase.TieOver
    rule['way-uo']['7-2'] = ruleBase.LoseOver

    rule['handi-uo']['3-1'] = ruleBase.HandiUnder
    rule['handi-uo']['3-2'] = ruleBase.HandiOver
    rule['handi-uo']['4-1'] = ruleBase.HandiUnder
    rule['handi-uo']['4-2'] = ruleBase.HandiOver
  } else {
    rule = _.cloneDeep(DefaultCombinationRuleExt)
    rule['way-uo']['1-13'] = ruleBase.WinUnder
    rule['way-uo']['2-13'] = ruleBase.TieUnder
    rule['way-uo']['3-13'] = ruleBase.LoseUnder
    rule['way-uo']['4-13'] = ruleBase.WinUnder
    rule['way-uo']['5-13'] = ruleBase.LoseUnder
    rule['way-uo']['1-12'] = ruleBase.WinOver
    rule['way-uo']['2-12'] = ruleBase.TieOver
    rule['way-uo']['3-12'] = ruleBase.LoseOver
    rule['way-uo']['4-12'] = ruleBase.WinOver
    rule['way-uo']['5-12'] = ruleBase.LoseOver

    rule['handi-uo']['1714-13'] = ruleBase.HandiUnder
    rule['handi-uo']['1714-12'] = ruleBase.HandiOver
    rule['handi-uo']['1715-13'] = ruleBase.HandiUnder
    rule['handi-uo']['1715-12'] = ruleBase.HandiOver
  }

  rule.special = ruleBase.SpecialCombination
  return rule
}

export class Mining {
  // 승무패, 언더오버 형식의 2 또는 3 컬럼 고정 형식인지를 리턴
  static isRegularMarket = (type: BET_TYPE_ON, market: string): boolean => {
    if (isLsportsEnv()) {
      if (type === BET_TYPE_ON.UNIFIED_MATCH || type === BET_TYPE_ON.UNIFIED_LIVE) {
        return LS_REGULAR_ODDS.indexOf(market) >= 0
      }
      return LEGACY_REGULAR_ODDS.indexOf(market) >= 0
    }
    if (type === BET_TYPE_ON.UNIFIED_MATCH || type === BET_TYPE_ON.UNIFIED_LIVE) {
      return UNIFIED_REGULAR_ODDS.indexOf(market) >= 0
    }
    return LEGACY_REGULAR_ODDS.indexOf(market) >= 0
  }

  static sortOutcome = (type: BET_TYPE_ON, outcomes: Schema$Outcome[]) => {
    if (type === BET_TYPE_ON.UNIFIED_MATCH || type === BET_TYPE_ON.UNIFIED_LIVE) {
      if (isLsportsEnv()) {
        outcomes.sort((a, b) => {
          return LS_REGULAR_OUTCOMES.indexOf(a.metaId) - LS_REGULAR_OUTCOMES.indexOf(b.metaId)
        })
      } else {
        outcomes.sort((a, b) => {
          return UNIFIED_REGULAR_OUTCOMES.indexOf(a.type) - UNIFIED_REGULAR_OUTCOMES.indexOf(b.type)
        })
      }
    } else {
      outcomes.sort((a, b) => {
        return LEGACY_REGULAR_OUTCOMES.indexOf(a.type) - LEGACY_REGULAR_OUTCOMES.indexOf(b.type)
      })
    }
  }

  // unified support
  static isRegularOutcomeWay = (market: string): boolean => {
    if (isLsportsEnv()) {
      return LS_REGULAR_ODDS_WAY.indexOf(market) >= 0
    }
    return UNIFIED_REGULAR_ODDS_WAY.indexOf(market) >= 0
  }

  static isRegularOutcomeHandicap = (market: string): boolean => {
    if (isLsportsEnv()) {
      return LS_REGULAR_ODDS_HANDICAP.indexOf(market) >= 0
    }
    return UNIFIED_REGULAR_ODDS_HANDICAP.indexOf(market) >= 0
  }

  static isRegularOutcomeUnderOver = (market: string): boolean => {
    if (isLsportsEnv()) {
      return LS_REGULAR_ODDS_UNDEROVER.indexOf(market) >= 0
    }
    return UNIFIED_REGULAR_ODDS_UNDEROVER.indexOf(market) >= 0
  }
}

// NOTE : 서버에서 내려주는 speifiers key 값들
const specifiersKeys = [
  'hcp',
  'total',
  'server',
  'inningnr',
  'player',
  'inningnr+1',
  'inningnr+2',
  'minute',
  'minute-1',
  'bookingnr',
  'cornernr',
  'daynr',
  'drivenr',
  'playnr',
  'competitor',
  'fieldgoalnr',
  'framenr',
  'freethrownr',
  'gamenr',
  'pointnr',
  'pointnr',
  'goalnr',
  'inningnr',
  'dismissalnr',
  'upsnr',
  'competitor1',
  'competitor2',
  'player',
  'milestone',
  'overnr',
  'deliverynr',
  'overnrX',
  'overnrY',
  'mapnr',
  'xth',
  'roundnr',
  'xth',
  'from',
  'to',
  'killnr',
  'periodnr',
  'cp',
  'quarternr',
  'runnr',
  'scorenr',
  'setnr',
  'gamenrX',
  'gamenrY',
  'games',
  'pointnr',
  'endnr',
  'gamenr',
  'legnr',
  'timeoutnr',
  'touchdownnr',
  'c1goalnr',
  'c1scorenr',
  'score',
  'visitnr',
  'total',
  'points',
  'c2goalnr',
  'c2scorenr',
  'event',
  'pos',
  'group',
  'matchday',
  'pitchnr',
  'penaltynr',
  'goals',
  'cornernr',
  'framenr',
  'goalnr',
  'pointnr',
  'runnr',
  'hitnr',
]

// lib/v2/utils 중복
export const specifiersMarketName = (marketName: string, specifers: { [id: string]: string }) => {
  let final_name = marketName
  for (const spec in specifers) {
    if (final_name.indexOf('!') >= 0) {
      final_name = final_name.replace(`{!${spec}}`, specifers[spec])
    } else if (marketName.indexOf('$') >= 0) {
      final_name = final_name.replace(`{$${spec}}`, specifers[spec])
    } else if (marketName.indexOf('%') >= 0) {
      final_name = final_name.replace(`{%${spec}}`, specifers[spec])
    } else {
      final_name = final_name.replace(`{${spec}}`, specifers[spec])
    }
  }

  return final_name
}

// lib/v2/utils 중복
export const specifierMarketName = (marketName: string, speciferkey: string, specifervalue: string) => {
  let final_name = marketName
  if (final_name.indexOf('!') >= 0) {
    final_name = final_name.replace(`{!${speciferkey}}`, specifervalue)
  } else if (marketName.indexOf('$') >= 0) {
    final_name = final_name.replace(`{$${speciferkey}}`, specifervalue)
  } else if (marketName.indexOf('%') >= 0) {
    final_name = final_name.replace(`{%${speciferkey}}`, specifervalue)
  } else {
    final_name = final_name.replace(`{${speciferkey}}`, specifervalue)
  }
  return final_name
}

export const replaceMarketName = (name: string, homeTeamName = '', awayTeamName = '') => {
  // return name
  //   .replace(/1x2/g, '승무패')
  //   .replace(/승자/g, '승패')
  //   .replace(/토탈/g, '언더오버')
  //   .replace(/합계/g, '언더오버')
  //   .replace('{hcp}', '')
  //   .replace('{total}', '')
  //   .replace('[{score}]', '')
  //   .split('{$competitor1}')
  //   .join(homeTeamName || '홈')
  //   .split('{$competitor2}')
  //   .join(awayTeamName || '어웨이')
  return name
    .replace('{hcp}', '')
    .replace('{total}', '')
    .replace('[{score}]', '')
    .split('{$competitor1}')
    .join(homeTeamName)
    .split('{$competitor2}')
    .join(awayTeamName)
}

export const replaceOutcomeName = (name: string, specifiers = '', homeTeamName = '홈', awayTeamName = '원정') => {
  return name
    .replace(/({total})/g, specifiers)
    .replace('{+hcp}', specifiers)
    .replace('{-hcp}', (_.isEmpty(specifiers) ? specifiers : Number(specifiers) * -1).toString())
    .replace('{hcp}', specifiers)
    .replace('{%server}', specifiers)
    .replace('{!inningnr}', specifiers)
    .replace('{!inningnr+1}', specifiers)
    .replace('{!inningnr+2}', specifiers)
    .replace('{%player} ', specifiers)
    .replace('{minute}', specifiers)
    .replace('{minute-1}', specifiers)
    .split('{$competitor1}')
    .join(`${homeTeamName}`)
    .split('{$competitor2}')
    .join(`${awayTeamName}`)
}

export const replaceOutcomeNameSpec = (
  name: string,
  homeTeamName = '',
  awayTeamName = '',
  specifiers?: { [p: string]: string }, // { [id: string]: string },
) => {
  let specifier = ''
  if (specifiers) {
    for (const el of Object.keys(specifiers)) {
      if (specifiersKeys.indexOf(el) !== -1) {
        specifier = specifiers[el]
        break
      }
    }
  }

  return replaceOutcomeName(name, specifier, homeTeamName, awayTeamName)
}

export const PlayingPeriodSpecifierKey = [
  'quarternr',
  'inningnr',
  'setnr',
  'gamenr',
  'mapnr',
  'goalnr',
  'framenr',
  'periodnr',
  'pointnr',
  'runnr',
]

// export const PlayingPeriodMarkets = [
//   '{!quarternr}',
//   '{!inningnr}',
//   '{!setnr}',
//   '{!gamenr}',
//   '{!mapnr}',
//   // '{!goalnr}',
//   '{!framenr}',
//   '{!periodnr}',
// ]

export const PlayingPeriodExceptionMarket = ['756', '757']

// 차수 구분이 있는 게임 마켓(쿼터, 이닝, 세트 등) - lib/v2/utils 에도 있음.(중복)
export const isPlayingPeriodMarket = (marketType: string, name: string) => {
  if (PlayingPeriodExceptionMarket.indexOf(marketType) >= 0) {
    return false
  }

  for (const el of PlayingPeriodSpecifierKey) {
    const ret = name.indexOf(el) >= 0
    if (ret) {
      return true
    }
  }
  return false
}

export const isVariantOutcome = (name: string) => {
  return false
}

export function getClubSpcialBetMaxMoney(clubInfo: ClubInfo) {
  let maxBetMoney = Math.floor(clubInfo.pre_betmoney_max / 2)
  if (clubInfo.pre_betmoney_min > maxBetMoney) {
    maxBetMoney = clubInfo.pre_betmoney_min + 10000
  }
  return maxBetMoney
}

export function getClubMinMaxBet(typeOn: BET_TYPE_ON, betMoneyType: PROPERTY_ID, clubInfo: ClubOption) {

  const isLimitBetOnoff = globalStore.getClubLimBetOnOff()

  const club_bet = {
    betmoney_min: 0,
    betmoney_max: 0,
  }

  if (isLimitBetOnoff && betMoneyType !== PROPERTY_ID.DIA) {
    const clubGmoneyMaxBetLimit = globalStore.getClubGmoneyMaxBetLimit()

    if (typeOn === BET_TYPE_ON.UNIFIED_MATCH) {
      club_bet.betmoney_min = clubInfo.pre_betmoney_min
      club_bet.betmoney_max = clubGmoneyMaxBetLimit
    } else if (typeOn === BET_TYPE_ON.UNIFIED_LIVE) {
      club_bet.betmoney_min = clubInfo.live_betmoney_min
      club_bet.betmoney_max = clubGmoneyMaxBetLimit
    } else if (typeOn === BET_TYPE_ON.UNIFIED_SPECIAL) {
      club_bet.betmoney_min = clubInfo.pre_betmoney_min
      club_bet.betmoney_max = clubGmoneyMaxBetLimit
    } else if (typeOn === BET_TYPE_ON.MIX) {
      club_bet.betmoney_min = clubInfo.pre_betmoney_min > clubInfo.live_betmoney_min
        ? clubInfo.pre_betmoney_min : clubInfo.live_betmoney_min
      club_bet.betmoney_max = clubGmoneyMaxBetLimit
    } else {
      club_bet.betmoney_min = clubInfo.special_betmoney_min
      club_bet.betmoney_max = clubGmoneyMaxBetLimit
    }

    if(betMoneyType === PROPERTY_ID.NEW_BET_TICKET_G) {
      club_bet.betmoney_min /= RATIO_TICKET
    }
  } else {
    if (typeOn === BET_TYPE_ON.UNIFIED_MATCH) {
      club_bet.betmoney_min = clubInfo.pre_betmoney_min
      club_bet.betmoney_max = clubInfo.pre_betmoney_max
    } else if (typeOn === BET_TYPE_ON.UNIFIED_LIVE) {
      club_bet.betmoney_min = clubInfo.live_betmoney_min
      club_bet.betmoney_max = clubInfo.live_betmoney_max
    } else if (typeOn === BET_TYPE_ON.UNIFIED_SPECIAL) {
      club_bet.betmoney_min = clubInfo.pre_betmoney_min
      club_bet.betmoney_max = getClubSpcialBetMaxMoney(clubInfo)
    } else if (typeOn === BET_TYPE_ON.MIX) {
      club_bet.betmoney_min = clubInfo.pre_betmoney_min > clubInfo.live_betmoney_min
        ? clubInfo.pre_betmoney_min : clubInfo.live_betmoney_min
      club_bet.betmoney_max = clubInfo.pre_betmoney_max > clubInfo.live_betmoney_max
        ? clubInfo.live_betmoney_max : clubInfo.pre_betmoney_max
    } else {
      club_bet.betmoney_min = clubInfo.special_betmoney_min
      club_bet.betmoney_max = clubInfo.special_betmoney_max
    }

    if(betMoneyType === PROPERTY_ID.NEW_BET_TICKET_G)  {
      club_bet.betmoney_min /=  RATIO_TICKET
      club_bet.betmoney_max  /= RATIO_TICKET
    }
  }

  return club_bet
}

export function getClubMaxBet(pre_betmoney_max: number, live_betmoney_max: number) {
  const isLimitBetOnoff = globalStore.getClubLimBetOnOff()

  let pre_betmoney_text = null
  let live_betmoney_text = null
  if (isLimitBetOnoff) {
    const clubGmoneyMaxBetLimit = globalStore.getClubGmoneyMaxBetLimit()
    pre_betmoney_text = formatNumber(clubGmoneyMaxBetLimit)
    live_betmoney_text = formatNumber(clubGmoneyMaxBetLimit)
  } else {
    pre_betmoney_text = pre_betmoney_max >= 0 ? formatNumber(pre_betmoney_max) : '무제한'
    live_betmoney_text = live_betmoney_max >= 0 ? formatNumber(live_betmoney_max) : '무제한'
  }

  return {
    pre_betmoney_text,
    live_betmoney_text,
  }
}

const BTN_LIMIT_ON_MAX_MONEY = 500000
const BTN_LIMIT_OFF_MAX_MONEY = 1000000

export function getBtnMaxBetMoney(isLimit:boolean) {
  return isLimit ? BTN_LIMIT_ON_MAX_MONEY : BTN_LIMIT_OFF_MAX_MONEY
}

export function isSpecialTabAvailable(clubRules: ClubRules) {
  if (_.isNil(clubRules)) {
    return false
  }

  return clubRules.specialSingleUse || clubRules.specialMultiUse
}

export function getMatchTime(
  sportId: SPORT_ID | LS_SPORT_ID, timeline: TimelineEvent, defaultTime?:number | string
): number | null {
  if (timeline.type === TimelineEventType.PERIOD_START
    || timeline.type === TimelineEventType.BREAK_START
    || timeline.type === TimelineEventType.PERIOD_SCORE) {
    return null
  }
  let matchTime
  if (sportId === SPORT_ID.SOCCER || sportId === LS_SPORT_ID.FOOTBALL) {
    matchTime = timeline.matchTime
    if (_.isNil(matchTime) && timeline.matchClock) {
      matchTime = Number(timeline.matchClock.split(':')[0])
    }
  } else {
    matchTime = timeline.matchClock
    if (_.isNil(matchTime) && timeline.matchTime) {
      matchTime = `${timeline.matchTime}:00`
    }
  }
  if (_.isNil(matchTime) && !_.isNil(defaultTime)) {
    const durationTime = dayjs.duration(dayjs(timeline.time).diff(dayjs(defaultTime)))
    matchTime = durationTime.minutes()
    if (sportId !== SPORT_ID.SOCCER && sportId !== LS_SPORT_ID.FOOTBALL) {
      matchTime = `${matchTime}:${durationTime.seconds()}`
    }
  }
  return matchTime
}

export function isEmptyList(listItem: any[]): boolean {
  let result = false
  if (_.isEmpty(listItem)) {
    result = true
  } else {
    let emptyCount = 0
    _.forEach(listItem, item => {
      if (_.isEmpty(item)) {
        emptyCount += 1
      }
    })
    if (emptyCount === _.size(listItem)) {
      result = true
    }
  }
  return result
}

export function makeSelectionValue(params: {
  marketType: string,
  specifiers: string,
  outcomeType: any,
  rate: number,
  outcomeMetaId: any,
  key: string,
  producerId: ProducerType,
}): string {
  const { marketType, specifiers, outcomeType, rate, outcomeMetaId, key, producerId } = params
  return `${marketType}//${specifiers}//${outcomeType}//${rate}//${outcomeMetaId || key}//${producerId}`
}
